import Vue from 'vue'
import Vuex from 'vuex'
import seal from './modules/seal'
import user from './modules/user'
import semTest from './modules/semTest'
import abTest from './modules/abTest'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    seal,
    user,
    semTest,
    abTest
  },
})
